import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconEmail = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 18'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M21.000,18.000 L3.000,18.000 C1.346,18.000 0.000,16.654 0.000,15.000 L0.000,3.000 C0.000,1.346 1.346,0.000 3.000,0.000 L21.000,0.000 C22.654,0.000 24.000,1.346 24.000,3.000 L24.000,15.000 C24.000,16.654 22.654,18.000 21.000,18.000 ZM3.000,16.000 L21.000,16.000 C21.551,16.000 22.000,15.551 22.000,15.000 L22.000,3.203 L12.628,10.778 C12.445,10.926 12.223,11.000 12.000,11.000 C11.777,11.000 11.555,10.926 11.372,10.778 L2.000,3.203 L2.000,15.000 C2.000,15.551 2.449,16.000 3.000,16.000 ZM20.307,2.000 L3.693,2.000 L12.000,8.715 L20.307,2.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconEmail.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
